module.exports = __webpack_public_path__ + "static/media/banner_animation_mobile.2c57ca16.mp4";